"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeUtils = void 0;
var moment_1 = __importDefault(require("moment"));
var ITypes_1 = require("../type/ITypes");
var includeTimeToDate = function (date, hour, minute) {
    return (0, moment_1.default)(date)
        .set({
        hour: hour,
        minute: minute
    })
        .toDate();
};
var momentFormatter = function (str, format) {
    return !(0, moment_1.default)(str, format, true).isValid()
        ? ''
        : (0, moment_1.default)(str, format).format(format);
};
var momentTwoFormatter = function (str, format1, format2) {
    if (!str)
        return '';
    return !(0, moment_1.default)(str, format1, true).isValid()
        ? ''
        : (0, moment_1.default)(str, format1).format(format2);
};
var isValidDate = function (date) { return !!date && (0, moment_1.default)(date).isValid(); };
var buildRangeDate = function (state, dateType) {
    var start = state.start, end = state.end;
    var startDate = start.date, startTime = start.time;
    var endDate = end.date, endTime = end.time;
    var responseDate = [null, null];
    var formatExpression = function (date, isDate) {
        return momentTwoFormatter(date, moment_1.default.defaultFormat, isDate ? ITypes_1.FormatDefaultDate : ITypes_1.FormatDefaultTime);
    };
    switch (dateType) {
        case 'TIME':
            responseDate = [startTime, endTime];
            break;
        case 'DATE':
            responseDate = [startDate, endDate];
            break;
        case 'DATETIME':
            var date1 = formatExpression(startDate, true);
            var date2 = formatExpression(endDate, true);
            var time1 = formatExpression(startTime, false);
            var time2 = formatExpression(endTime, false);
            var dateTime1 = (0, moment_1.default)("".concat(date1, " ").concat(time1), ITypes_1.FormatDefaultDateTime).toDate();
            var dateTime2 = (0, moment_1.default)("".concat(date2, " ").concat(time2), ITypes_1.FormatDefaultDateTime).toDate();
            responseDate = [
                (0, moment_1.default)(dateTime1).isValid() ? dateTime1 : null,
                (0, moment_1.default)(dateTime2).isValid() ? dateTime2 : null
            ];
    }
    return responseDate;
};
var initialDate = function (fieldState, value, startValueTime, endValueTime) {
    var _a, _b, _c, _d;
    var startDate = ((_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) === null || _a === void 0 ? void 0 : _a[0]) || (value === null || value === void 0 ? void 0 : value[0]);
    var endDate = ((_b = fieldState === null || fieldState === void 0 ? void 0 : fieldState.value) === null || _b === void 0 ? void 0 : _b[1]) || (value === null || value === void 0 ? void 0 : value[1]);
    var defaultConfig = {
        start: {
            date: ((_c = (0, moment_1.default)(startDate)) === null || _c === void 0 ? void 0 : _c.isValid()) ? startDate : null,
            time: startValueTime
                ? startValueTime
                : exports.DateRangeUtils.includeTimeToDate((0, moment_1.default)().toDate(), 24, 0)
        },
        end: {
            date: ((_d = (0, moment_1.default)(endDate)) === null || _d === void 0 ? void 0 : _d.isValid()) ? endDate : null,
            time: endValueTime
                ? endValueTime
                : exports.DateRangeUtils.includeTimeToDate((0, moment_1.default)().toDate(), 23, 59)
        }
    };
    var buildState = function (range) {
        if (range.length === 2 && range.some(function (it) { return !!it; })) {
            var start = range[0], end = range[1];
            var defaultConfigStart = defaultConfig.start, defaultConfigEnd = defaultConfig.end;
            return {
                start: getTimeAndDate((0, moment_1.default)(start).isValid() ? start : null, defaultConfigStart),
                end: getTimeAndDate((0, moment_1.default)(end).isValid() ? end : null, defaultConfigEnd)
            };
        }
        return defaultConfig;
    };
    if (fieldState) {
        return buildState(fieldState.value);
    }
    if (value) {
        return buildState(value);
    }
    return defaultConfig;
};
var getTimeAndDate = function (date, defaultConfig) {
    if (date) {
        var dateParse = (0, moment_1.default)("".concat(date)).format('MM-DD-YYYY');
        var timeParse = (0, moment_1.default)("".concat(date)).format('hh:mm A');
        return {
            date: (0, moment_1.default)("".concat(dateParse), ITypes_1.FormatDefaultDate).toDate(),
            time: (0, moment_1.default)("".concat(dateParse, " ").concat(timeParse), ITypes_1.FormatDefaultDateTime).toDate()
        };
    }
    return defaultConfig;
};
var transformState = function (state) {
    var start = state.start, end = state.end;
    var startDate = start.date, startTime = start.time;
    var endDate = end.date, endTime = end.time;
    return { startDate: startDate, startTime: startTime, endDate: endDate, endTime: endTime };
};
exports.DateRangeUtils = {
    includeTimeToDate: includeTimeToDate,
    momentFormatter: momentFormatter,
    momentTwoFormatter: momentTwoFormatter,
    buildRangeDate: buildRangeDate,
    isValidDate: isValidDate,
    initialDate: initialDate,
    transformState: transformState
};
